import { useEffect } from "react";
import { tagGtmStart, tagSimularOrigem } from "../../utils/sendTag";

const GoogleTagManager = ({ gtmId, brand, siteDomain, tipoOrigem = "bot" }) => {
  useEffect(() => {
    if (window.__gtmLoaded) return;
    window.__gtmLoaded = true;

    window.dataLayer = window.dataLayer || [];
    window.plano_selecionado = {};
    window.planos_disponiveis = [];

    tagSimularOrigem(brand, siteDomain, tipoOrigem);
    tagGtmStart();

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [gtmId, brand, siteDomain, tipoOrigem]);

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        height="0"
        width="0"
        style={{ display: "none", visibility: "hidden" }}
        title="Google Tag Manager"
      ></iframe>
    </noscript>
  );
};

export default GoogleTagManager;
